<template>
  <div class="big-screen-adapter" :style="`background-color: ${$route.meta.bgColor}`">
    <div class="screen" id="screen"
      :style="`width: ${$route.meta.basicScreenWidth}px;height: ${$route.meta.basicScreenHeight}px`">
      <slot />
    </div>
  </div>
</template>
<script>
import Big from "big.js";
export default {
  mounted() {
    // 初始化自适应  ----在刚显示的时候就开始适配一次
    this.handleScreenAuto();
    // 绑定自适应函数   ---防止浏览器栏变化后不再适配
    window.addEventListener('resize', this.handleScreenAuto)
  },
  destroyed() {
    window.addEventListener('resize', null)
  },
  methods: {
    handleScreenAuto() {
      const designDraftWidth = new Big(this.$route.meta.basicScreenWidth).plus(1); //设计稿的宽度
      const designDraftHeight = new Big(this.$route.meta.basicScreenHeight).plus(1); //设计稿的高度
      const clientWidth = new Big(document.documentElement.clientWidth)
      const clientHeight = new Big(document.documentElement.clientHeight)
      console.log(clientHeight.toNumber(), clientWidth.toNumber())
      let flag = true
      function debounce() {
        if (flag) {
          flag = false
          let time = setTimeout(() => {
            clearTimeout(time)
            // 根据屏幕的变化适配的比例
            const scale = clientWidth.div(clientHeight).lt(designDraftWidth.div(designDraftHeight)) ? clientWidth.div(designDraftWidth).toNumber() : clientHeight.div(designDraftHeight).toNumber()
            // 缩放比例
            document.querySelector(
              '#screen',
            ).style.transform = `scale(${scale}) translateX(-50%) translateY(-50%)`;
            flag = true
          }, 100)
        }
      }
      debounce()
    }
  }
}
</script>

<style lang="scss" scoped>
.big-screen-adapter {
  width: 100vw;
  height: 100vh;

  .screen {
    transform-origin: 0 0;
    position: absolute;
    transition: all .3s ease;
    transform: scale(0.5) translateX(-50%) translateY(-50%);
    left: 50%;
    top: 50%;
  }
}
</style>
<style>
body {
  margin: 0;
  padding: 0;
  overflow: hidden;
}
</style>